<template>
   <div class="create-accordian-section">
      <div class="main-contents">
        <ul class="breadcrumbs-list">
          <a href="javascript:void(0)" @click="backButton"><li>Value Added Services</li></a>
          <li>&nbsp;>&nbsp;My WILL</li>
        </ul>
        <h3>
          <span style="color: #1a407d; font-size: 27px"> MY</span>
          <span style="color: #f19700; font-size: 18px; top: 12px"> WILL</span>
        </h3>
        <div>
          <div class="will-creation-progress">
            <h2 class="head">The following WILL {{ this.$route.params.type == 'create' ? 'Creation':'Amendation' }} is in progress</h2>
            <div class="will-creation-profile">
              <div class="will-creation-profile-content" v-for="(will, index) in wills" :key="index">
                <h2>Member {{index+1}}</h2>
                <div class="d-flex">
                  <div class="input-field">
                    <input
                      type="text"
                      class="form-control"
                      :placeholder="will.name"
                    />
                  </div>
                  <button class="will-button1 reviewBtn" @click="preview(will.id)">GO TO PREVIEW</button>
                </div>
              </div>
              <!-- <div class="will-creation-profile-content">
                <h2>Member 2</h2>
                <div class="d-flex">
                  <div class="input-field">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Ritesh Verma"
                    />
                  </div>
                  <button class="will-button1 reviewBtn">GO TO PREVIEW</button>
                </div>
              </div> -->
            </div>
            <div class="will-creation-content">
              <p>
                We have saved your last updated information.
                <br> In order to proceed please click on <a href="#" class="blue-content">“Preview”</a> to view
                and edit your information. You can generate your WILL once you
                <span class="blue-content"> “Confirm” </span>the details entered. 
                <br>
                <span>You have 10 days left to Preview and Close.</span>
              </p>
              <p>
                Post which your information will be removed and you have to start
                afresh.
              </p>
            </div>
            <div class="line"></div>
            <h2 class="subhead">Create/Amend Will for other members</h2>
            <p class="subtitle">
              If you want to create/amend a WILL for another member please click on
              <a class="blue-content">“Proceed”</a> below
            </p>
            <div class="button-group">
              <button class="btn cancle-btn">CANCEL</button>
              <button class="btn save-btn" @click="proceed()">PROCEED</button>
            </div>
          </div>
        </div>
      </div>
   </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data: () => ({
      wills:[]
    }),
    mounted() {
      axios.post(
        process.env.VUE_APP_ROOT_API + "get-pending-wills",
        {
          aws_cognito_id:atob(localStorage.getItem('cognito_idp')),
          type:this.$route.params.type
        }
      )
      .then((response) => {
        this.wills = response.data.data
      })
    },
    methods: {
      proceed() {
        this.$router.push({ path: '/WillPayment' }).catch(() => {});
      },
      backButton() {
  		  this.$router.push({ name: 'ValueAddedServices' }).catch(() => {});
  		},
      preview(will_id) {
        this.$router.push({ path: '/memberwill/'+this.$route.params.type+'/'+will_id }).catch(() => {});
      },
    },
  };
</script>